import { OrderStyleType } from 'data/types'
import webSocket from 'services/api/webSocket'

const getOriginalTimestamp = () => new Date().toISOString()

const utmParser = (query: string): { [key: string]: string } => {
  const regexp = /(?!&)utm_[^=]*=[^&]*/g

  const matches = query.match(regexp)

  if (!matches) return {}

  const values = matches.reduce((obj, param) => {
    const keyValue = param.split('=')

    let key = keyValue[0].slice(keyValue[0].indexOf('_') + 1)

    if (key === 'campaign') {
      key = 'name'
    }

    const value = keyValue[1]

    return { ...obj, [key]: value }
  }, {})

  return values
}

export const mapTypeToTrackings = (type: OrderStyleType) => {
  if (type === webSocket.order.type.MARKET) return 'MARKET'
  if (type === webSocket.order.type.LIMIT) return 'LIMIT'
  if (type === webSocket.order.type.STOP) return 'STOP'
  if (type === webSocket.order.type.STOP_LIMIT) return 'STOP_LIMIT'
}

export { getOriginalTimestamp, utmParser }
